"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var semantic_ui_react_1 = require("semantic-ui-react");
var searchParamsSlice_1 = require("../../../features/searchParams/searchParamsSlice");
var lodash_1 = __importDefault(require("lodash"));
var BuildingNameAutoComplete = function (_a) {
    var _b = _a.filter, label = _b.label, name = _b.name, onSelect = _a.onSelect, appliedFilters = _a.appliedFilters;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var buildingNames = react_redux_1.useSelector(searchParamsSlice_1.useSelectBuildingNames);
    var _c = react_1.useState(''), value = _c[0], setValue = _c[1];
    react_1.useEffect(function () {
        value.length && dispatch(searchParamsSlice_1.getBuildingNames(value));
    }, [value]);
    react_1.useEffect(function () {
        var _a;
        if ((_a = appliedFilters[name]) === null || _a === void 0 ? void 0 : _a.length) {
            setValue(appliedFilters[name][0]);
        }
    }, [appliedFilters]);
    var changeHandler = function (value) {
        setValue(value);
    };
    var debouncedChangeHandler = react_1.useCallback(lodash_1.default.debounce(changeHandler, 300), []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "filter-summary" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null, t('FILTER.' + label.toUpperCase())))),
        react_1.default.createElement(semantic_ui_react_1.Dropdown, { clearable: true, fluid: true, search: true, selection: true, options: buildingNames, onSearchChange: function (event, data) {
                return debouncedChangeHandler(data.searchQuery);
            }, onChange: function (event, data) { return onSelect(String(data.value)); }, noResultsMessage: null, defaultValue: value })));
};
exports.default = BuildingNameAutoComplete;
